import { useTranslation } from 'react-i18next';
import Select, { type SingleValue } from 'react-select';

// Import components
import { Control } from './Control';

// Import styles
import { SelectContainer } from './styles';

// Import types
import type { SelectOption, SelectFieldType, FormFieldProps } from 'types/views/form';

// Import utilities
import { useHookFormField } from 'components/utilities';

type Props = FormFieldProps<SelectFieldType>;

const SelectComponent = (props: Props) => {
	const { t } = useTranslation();
	const { field, isError, isDisabled } = useHookFormField(props);

	const value = props.options.filter(({ value }) => value === field.value);

	const onChange = (newValue: SingleValue<SelectOption>) => field.onChange(newValue?.value);

	return (
		<SelectContainer isError={isError}>
			<Select
				ref={field.ref}
				options={props.options}
				classNamePrefix="select"
				components={{ Control: (controlProps) => <Control {...controlProps} label={t(props.label)} isError={isError} /> }}
				unstyled={true}
				name={field.name}
				value={value}
				onChange={onChange}
				onBlur={field.onBlur}
				isDisabled={isDisabled}
				placeholder=" "
				required={props.required}
			/>
		</SelectContainer>
	);
};

export default SelectComponent;
